import React, { memo, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { isMobile, isTablet } from "react-device-detect";

type item = {
  "VehicleId": string;
  "AccountId": string;
  "AccountName": string;
  "VehiclePlate": string;
  "VehicleCode": string;
  "FleetName": string;
  "Make": string;
  "Model": string;
  "RucMonkeyVehicleTypeId": string;
  "RucMonkeyVehicleTypeName": string;
  "SensorId": string;
  "SensorSerialNumber": string
};

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: (arg0: number) => void;
  items: item[];
  paging: any;
}

const VehicleItem = ({ pageSizeChanged, pageNoChanged, items, paging }: IProps) => {


  const onPage = (e: any) => {

    const { page, rows } = e;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);

    const datatableList = document.getElementsByClassName("p-datatable-scrollable-body");
    if (datatableList.length > 0) {
      datatableList[0].scrollTop = 0;
    }

  }, [items]);



  const setNormalDataTable = () => {
    return (
      <DataTable
        rowHover
        style={{ position: "relative" }}

        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable scrollHeight="calc(100vh - 390px)"

      >
        <Column field="VehiclePlate" header="Vehicle Plate" />
        <Column field="VehicleCode" header="Vehicle Code" />
        <Column field="FleetName" header="Fleet Name" />
        <Column field="Make" header="Make" />
        <Column field="Model" header="Model" />
        <Column field="RucMonkeyVehicleTypeName" header="Vehicle Type" />
        <Column field="SensorId" header="Sensor Id" />
        <Column field="SensorSerialNumber" header="Serial Number" />
      </DataTable>
    );
  };

  const setResponsiveContents = (title: string, contents: any, isTitle = true) => {
    return (
      <>
        {isTitle && <span className="p-column-title">{title}</span>}
        <span className="p-column-content">{contents}</span>
      </>
    );
  };

  const setResponsiveDataTable = () => {
    return (
      <DataTable
        header='Vehicles'
        style={{ position: "relative" }}
        value={items}
        className="p-datatable-responsive p-datatable-sm "
        paginator
        paginatorTemplate="CurrentPageReport  PageLinks  RowsPerPageDropdown"
        currentPageReportTemplate=" {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
      >
        <Column header="Vehicle Plate" body={(r: item) => setResponsiveContents('Vehicle Plate', r.VehiclePlate)} />
        <Column header="Vehicle Code" body={(r: item) => setResponsiveContents('Vehicle Code', r.VehicleCode)} />
        <Column header="Fleet Name" body={(r: item) => setResponsiveContents('Fleet Name', r.FleetName)} />
        <Column header="Vehicle Type" body={(r: item) => setResponsiveContents('Vehicle Type', r.RucMonkeyVehicleTypeName)} />
        <Column header="Sensor Id" body={(r: item) => setResponsiveContents('Sensor Id', r.SensorId)} />
        <Column header="Serial Number" body={(r: item) => setResponsiveContents('Serial Number', r.SensorSerialNumber)} />
      </DataTable>
    );
  };


  const setDataTable = () => {
    if (isMobile && !isTablet) {
      return setResponsiveDataTable();
    }
    else {
      return setNormalDataTable();
    }
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setDataTable()}
      </div>

    </>
  );

};

export default memo(VehicleItem);